import { render } from "./CxAttribution.vue?vue&type=template&id=28a1395c&scoped=true"
import script from "./CxAttribution.vue?vue&type=script&lang=js"
export * from "./CxAttribution.vue?vue&type=script&lang=js"

import "./CxAttribution.vue?vue&type=style&index=0&id=28a1395c&lang=less&scoped=true"

import exportComponent from "/home/ec2-user/workspace/_conx-ui-monorepo_ui2_lab_master/apps/ui2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28a1395c"]])

export default __exports__